/**
 * @file Expert dashboard UI — pages/Dashboard/Expert/components/ExpertDatasetSearchBar.tsx.
 */

import React from "react";
import "../../../../components/common/DataTable.css";
import "../AllDataset/ExpertAllDataset.css";

interface Props {
  value: string;
  onChange: (value: string) => void;
}

const ExpertDatasetSearchBar: React.FC<Props> = ({ value, onChange }) => (
  <div className="material-overview-header">
    <div className="material-overview-left">
      <div className="data-table-search">
        <svg
          className="search-icon"
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          aria-hidden="true"
        >
          <path
            d="M7.33333 12.6667C10.2789 12.6667 12.6667 10.2789 12.6667 7.33333C12.6667 4.38781 10.2789 2 7.33333 2C4.38781 2 2 4.38781 2 7.33333C2 10.2789 4.38781 12.6667 7.33333 12.6667Z"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M14 14L11.1 11.1"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
        <input
          type="text"
          placeholder="Search by submission code, contributor name, or email..."
          className="data-table-search-input"
          value={value}
          onChange={(e) => onChange(e.target.value)}
        />
      </div>
    </div>
  </div>
);

/** React component — Expert Dataset Search Bar. */
export default ExpertDatasetSearchBar;
